<!-- @veltra/icons generated sha256:1e31b6f71575ad30 gen:8 source:src/svg/normal/user-circle.svg -->
<script setup lang="ts">
defineOptions({ name: 'UserCircle' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0m-7 2c1.786 0 3.475.477 4.996 1.325a6 6 0 1 0-9.991 0C4.525 10.477 6.215 10 8 10m2.78-3.78a2.78 2.78 0 1 1-5.56 0 2.78 2.78 0 0 1 5.56 0m-4.56 0a1.78 1.78 0 1 0 3.56 0 1.78 1.78 0 0 0-3.56 0M8 14c1.72 0 3.27-.723 4.363-1.882A9.2 9.2 0 0 0 8 11c-1.547 0-3.02.398-4.363 1.118A5.98 5.98 0 0 0 8 14"
      style="opacity: 0.9000000357627869"
    />
  </svg>
</template>
